export default __webpack_public_path__ + "static/sensitive-data-ce57ebb1577f06ac26f9bb3c88697081.png";